import React, { useState, useEffect } from 'react'
import cleanUrl from '../helpers/cleanUrl'

const NavBar = ({ url, isLoading, isPlaying }) => {

	const websiteUrl = cleanUrl(url)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setReady(true)
  }, [])

  return (
    <div className="navbar">
      <div className="dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="address-bar">
        <span>{websiteUrl}</span>
        <div className="loading" style={{
          width: isLoading && ready ? '88%' : '0%',
          transition: isPlaying ? '0.2s' : isLoading ? '6s' : '0s',
          opacity: isPlaying ? 0 : 1
        }}></div>
      </div>
    </div>
  )
}

export default NavBar
